<script setup lang="ts">
definePageMeta({ layout: 'bare' })
useHead({ title: 'Sign up — Regotiate' })
</script>

<template>
  <AuthForm mode="signup" />
</template>
